<template>
    <v-container fluid>
        <v-tooltip left dark v-if="!inContract">
            <template #activator='data'>
                <v-btn large text icon  @click="newObject()">
                    <v-icon medium color="success" v-on="data.on">mdi-plus</v-icon>
                </v-btn>
            </template>
            <span>{{ object.description }} aanmaken</span>  
        </v-tooltip>            

        <v-dialog 
            v-model="createObject.show"
            width="600" class="d-dialog">
            <v-card hover class="custom-card resize">
            
            <v-expand-transition mode="out-in">
              <iframe
                v-if="objectType == 'estate' && !initialHeader"
                id="gmap_canvas"
                width="100%"
                height="275px"
                :src="mapSource"
                frameborder="0"
                scrolling="no"
                marginheight="0"
                marginwidth="0"
              ></iframe>

              <v-card
              v-if="objectType != 'estate' || initialHeader"
                :color="app.color"
                :height="headerHeight(this.$vuetify)"
              >
                <v-container class="fill-height">                
                  <v-layout wrap justify-center="" align-center="" class="text-center">
                    <v-flex xs12 class="text-center">
                      <v-layout justify-center="" fill-height="" wrap>
                        <v-flex xs12>
                          <v-icon color="white" size="75">{{object.icon}}</v-icon>
                        </v-flex>
                        <v-flex xs12>
                          <span class="headline font-weight-thin white--text">{{object.description}} toevoegen</span>
                        </v-flex>
                        <v-flex xs12>
                          <span class="subheading font-weight-thin white--text">{{details.name}}</span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>               
                </v-container>
                
              </v-card>


            </v-expand-transition>
            
            <v-layout justify-end="" v-if="objectType != 'estate'">
              <v-tooltip left dark>
                <template #activator='data'>
                  <v-btn text icon>
                    <v-icon medium="" @click="multiple = !multiple" color="success" v-on="data.on" >mdi-inbox-multiple-outline</v-icon>                  
                  </v-btn>
                </template>
                <span>Meerdere toevoegen</span>
              </v-tooltip>
            </v-layout>        

            <forms-add-multiple-objects :object="object" v-if="multiple"></forms-add-multiple-objects>

            <div v-if="!multiple">

              <v-container fluid class="pa-5" v-if="objectType == 'estate'">
                <fields-d-address-field new estate></fields-d-address-field>
              </v-container>

              <v-container fluid class="pa-5" v-if="objectType == 'company'">
                <fields-d-text-field label="Bedrijfsnaam" v-model="details.name"></fields-d-text-field>
              </v-container>

              <v-container fluid class="pa-5" v-if="objectType == 'object'">
                <fields-d-text-field label="Beschrijving" v-model="details.name"></fields-d-text-field>
              </v-container>

              <v-container fluid v-if="objectType == 'person'">
                <v-layout row class="pa-5">
                  <v-flex>
                    <fields-d-text-field label="Voornaam" v-model="details.first_name"></fields-d-text-field>
                  </v-flex>
                  <v-flex class="pl-3">
                    <fields-d-text-field label="Achternaam" v-model="details.last_name"></fields-d-text-field>
                  </v-flex>
                </v-layout>
              </v-container>

              <v-layout justify-center="" style="min-height:78px;" v-if="!multiple">
                  <v-expand-transition>
                      <v-layout justify-center="">
                      <v-flex xs8>
                          <v-btn rounded block color="success" v-if="valid" @click="createdObject(object.reference, index)">aanmaken</v-btn>
                          <v-btn rounded block color="success" :disabled="!valid" v-if="!valid">aanmaken</v-btn>
                      </v-flex>
                      </v-layout>
                  </v-expand-transition>
              </v-layout>    

          </div>
          </v-card>
      </v-dialog>
    </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  data: () => ({
    details: {
      name: ""
    },
    multiple: false,
    valid: false
  }),
  props: {
    object: {
      type: Object,
      default: undefined
    },
    inContract: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    }
  },
  methods: {
    newObject(code) {
      this.details = {};
      this.valid = false;
      this.$store.dispatch("newObject");
    },
    createdObject(reference, index) {
      if (this.inContract == false) {
        this.$store.dispatch("createObject", {
          reference: reference,
          details: this.details,
          estate: this.containsVastgoed
        });
      } else if (this.inContract) {
        this.$store.dispatch("createObjectInContract", {
          reference: reference,
          details: this.details,
          index: index,
          estate: this.containsVastgoed
        });
        this.$store.state.app.contract.hasChange = true;
      }
      this.details = {};
    },
    setName() {
      if (
        this.details.first_name != "" &&
        this.details.first_name !== undefined
      ) {
        if (
          this.details.last_name != "" &&
          this.details.last_name !== undefined
        ) {
          this.details.name =
            this.details.first_name + " " + this.details.last_name;
        }
      }
    }
  },
  computed: {
    ...mapState([
      "user",
      "app",
      "createObject",
      "temp_address",
      "objects",
      "types"
    ]),
    ...mapGetters([
      "tempAddressName",
      "headerHeight",
      "addressDescription",
      "showCreatedObject"
    ]),
    initialHeader() {
      if (this.objectType == "estate") {
        if (this.tempAddressName == "" || this.tempAddressName === undefined) {
          return true;
        } else if (this.validObject == true) {
          return false;
        } else if (
          this.validObject == false ||
          this.validObject === undefined
        ) {
          return false;
        }
      } else {
        return false;
      }
    },
    objectType() {
      if (this.object.is_estate == true) {
        return "estate";
      } else if (this.object.is_company == true) {
        return "company";
      } else if (this.object.is_person == true) {
        return "person";
      } else {
        return "object";
      }
    },
    containsVastgoed() {
      // function to determine if the object that will be created is an estate property.
      if (this.objectType == "estate") {
        return true;
      } else {
        return false;
      }
    },
    mapSource() {
      if (
        this.$store.getters.addressDescription(true, null, this.temp_address) ==
        undefined
      ) {
        return "https://maps.google.com/maps?q=Nederland&output=embed&zoom=18";
      }
      return (
        "https://maps.google.com/maps?q=" +
        this.addressDescription(true, null, this.temp_address) +
        "&output=embed&zoom=18"
      );
    },
    validObject() {
      // result of checkExistobject is inverted in this case, when the object exists then the object should not be created
      if (this.details.name == "" || this.details.name === undefined) {
        return false;
      } else {
        console.log("calling validObject");
        return !this.$store.getters.checkExistObject(
          this.details.name,
          "name",
          this.object.reference
        );
      }
    },
    first_name() {
      return this.details.first_name;
    },
    last_name() {
      return this.details.last_name;
    },
    showDetails() {
      return this.details;
    }
  },
  watch: {
    object() {
      this.details = {};
      this.$store.state.temp_address = {};
    },
    first_name() {
      this.setName();
    },
    last_name() {
      this.setName();
    },
    tempAddressName() {
      // tempAdderssName copies the fetched address details to the temporary address details.
      // These are the object details for the object when the object is an estate object.

      //check for validity of the to be created object, this means if the object does already exist or not.
      this.valid = !this.$store.getters.checkExistObject(
        this.tempAddressName,
        "name",
        this.object.reference
      );

      // only run the function below when the new entry is valid.
      if (this.valid) {
        // process the previous stored temp_address object and store in the details of the to be created object.
        this.$store
          .dispatch("address/getAddressDetails", {
            vastgoed: this.containsVastgoed
          })
          .then(response => {
            console.log(response);
            this.details = response;
            this.details.name = this.tempAddressName;
            console.log("updated details", this.details);
          });
      }
    },
    validObject() {
      this.valid = this.validObject;
      console.log("object validity changed");
    }
  }
};
</script>

<style scoped>
.custom-card {
  border-radius: 20px !important;
}
.resize {
  min-height: 75vh;
}

.repeating-gradient {
  background-image: repeating-linear-gradient(
    -45deg,
    rgba(231, 231, 231, 0.1),
    rgba(231, 231, 231, 0.1),
    rgba(0, 49, 87, 0) 8px,
    rgba(0, 49, 87, 0) 15px
  );
}

.expand-x-transition {
  transition: all 4s ease;
}
</style>